import Question from './models'

export default Question
